import React from "react";
import ReactDOM from "react-dom";
import App from "./App.js";
import "./styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
